export default function docLogStatusColor(status, theme) {
  if (status.includes("rejected")) {
    return theme.palette.error.main;
  }
  if (status.includes("approved")) {
    return theme.palette.success.main;
  }

  switch (status) {
    case "unread":
      return theme.palette.primary.dark;
    case "read":
      return theme.palette.primary.light;
  }
}
